import React from 'react';

import { useIntl } from 'react-intl';

import GrowDiagonalIcon from '@atlaskit/icon/core/grow-diagonal';
import { fg } from '@atlaskit/platform-feature-flags/fg';
import { PanelActionExpand } from '@atlassian/panel-system';

import messages from '../../../common/messages';
import { PreviewPanelAction } from '../../../common/ui/preview-panel-action';
import type { PreviewPanelExpandProps } from './types';

/**
 * @private
 * @deprecated `@atlassian/preview-panel` is deprecated. Use `@atlassian/panel-system` instead.
 * {@link https://atlassian.design/components/panel-system/examples}
 */
export const PreviewPanelExpand = ({
	onClick,
	testId,
	analyticsContext,
}: PreviewPanelExpandProps): React.JSX.Element => {
	const { formatMessage } = useIntl();

	if (fg('ads-panel-system-gpp')) {
		if (analyticsContext) {
			return (
				<PreviewPanelAction
					label={formatMessage(messages.previewPanelExpandActionLabel)}
					icon={GrowDiagonalIcon}
					onClick={onClick}
					testId={testId}
					analyticsContext={analyticsContext}
				/>
			);
		}

		return (
			<PanelActionExpand
				onClick={onClick}
				testId={testId}
				label={formatMessage(messages.previewPanelExpandActionLabel)}
			/>
		);
	}

	return (
		<PreviewPanelAction
			label={formatMessage(messages.previewPanelExpandActionLabel)}
			icon={GrowDiagonalIcon}
			onClick={onClick}
			testId={testId}
			analyticsContext={analyticsContext}
		/>
	);
};
